<template>
  <BaseDialog
    :title="`${configurationModule.warehouse} Locations`"
    v-model="warehouseLocationDialog"
    width="60vw"
    cardTextClass="px-0 pb-0"
  >
    <template #information>
      <div class="background_color pa-4">
        <v-row no-gutters>
          <v-col cols="8" class="pr-4">
            <GoogleMap
              :hasMapInfo="true"
              id="warehouseLocation"
              mapWidth="10vw%"
              mapHeight="60vh"
              ref="warehouseLocation"
              :clusterMarkers="true"
            >
              <template #mapInfo>
                <MapInfo legendType="branchWarehouse" />
              </template>
            </GoogleMap>
          </v-col>
          <v-col cols="4">
            <v-card elevation="0" class="pa-4 d-flex">
              <h4 class="text-capitalize primary--text">
                {{ configurationModule.warehouse }} List
              </h4>
              <v-spacer></v-spacer>
              <v-chip
                class="text-capitalize primary"
                small
                v-if="warehouseList && warehouseList.length > 0"
              >
                {{ warehouseList.length }}
              </v-chip>
            </v-card>
            <div
              style="height: calc(60vh - 70px)"
              class="overflow-y-auto app-dialog-list"
            >
              <div v-for="(warehouse, index) in warehouseList" :key="index">
                <v-card
                  class="pa-4 my-2 card-box-shadow"
                  :class="
                    selectedWarehouseID.includes(warehouse.id)
                      ? 'selectColor'
                      : ''
                  "
                  elevation="0"
                  @click="selectWarehouse(warehouse)"
                >
                  <v-row no-gutters>
                    <v-col cols="3" class="d-flex justify-center algin-center">
                      <v-icon color="error"> mdi-store-marker-outline</v-icon>
                    </v-col>
                    <v-col cols="9">
                      <h4>{{ warehouse.name }}</h4>
                      <h5 class="font-weight-light">
                        {{ warehouse.address }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import { bus } from "@/main";
import { configurationModule } from "@/utils/moduleMapping";
export default {
  components: { BaseDialog, GoogleMap, MapInfo },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: [Number, null],
    },
    id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      configurationModule,
      warehouseList: [],
      branchDetails: {},
      selectedWarehouseList: [],
    };
  },
  computed: {
    warehouseLocationDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedWarehouseID() {
      return this.selectedWarehouseList.map((v) => v.id);
    },
  },
  watch: {
    warehouseLocationDialog(val) {
      if (val) {
        this.getBranchObject();
        this.setWarehouseLocation();
      }
    },
  },
  methods: {
    selectWarehouse(warehouseObject) {
      if (this.selectedWarehouseID.includes(warehouseObject.id)) {
        this.selectedWarehouseList = [];
      } else {
        this.selectedWarehouseList = [];
        this.selectedWarehouseList.push(warehouseObject);
      }

      if (this.selectedWarehouseList.length > 0) {
        this.$refs.warehouseLocation.removeAllMarkers();
        this.$refs.warehouseLocation.setDroppingLocation([warehouseObject]);
      } else {
        this.$refs.warehouseLocation.removeAllMarkers();
        this.$refs.warehouseLocation.setDroppingLocation(this.warehouseList);
      }
    },
    setBranchAndWarehouse() {

      let inter = setInterval(() => {
        if (
          this.$refs.warehouseLocation &&
          this.$refs.warehouseLocation.map &&
          window.google &&
          window.google.maps
        ) {
          clearInterval(inter);
          this.$refs.warehouseLocation.clearGeoJson();
          this.$refs.warehouseLocation.removeAllMarkers();
          this.$refs.warehouseLocation.initBounds();

          this.$refs.warehouseLocation.setDroppingLocation(this.warehouseList);

          this.$refs.warehouseLocation.addFeatures([
            { geometry: this.branchDetails.serviceable_area, type: "Feature" },
          ]);
        }
      });
      setTimeout(() => {
        clearInterval(inter);
      }, 3000);
    },
    getBranchObject() {
      this.$api.branch
        .getBranchObject(this.id)
        .then((res) => {
          this.branchDetails = res.data;
          this.setWarehouseLocation();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setWarehouseLocation() {
      bus.$emit("showLoader", true);
      this.$api.warehouse
        .getWarehouseList({ branch: this.id, limit: "all" })
        .then((res) => {
          this.warehouseList = res.data;
          this.warehouseList = this.warehouseList.map((v) => {
            v.location_type = "warehouse";
            return v;
          });
          this.setBranchAndWarehouse();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style lang="scss">
.selectColor {
  border: 1px solid var(--v-primary-lighten1) !important;
}
.app-dialog-list::-webkit-scrollbar {
  width: 10px;
}

.app-dialog-list::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.app-dialog-list::-webkit-scrollbar-thumb {
  background-color: var(--v-primary-base) !important;
}
</style>
